import React from 'react';
import PropTypes from 'prop-types';

import { getSession, getAPPID, getFlowType, enableSelfSetup } from '../../../Helpers/index';
import CommonSection from '../../redesign/component/commonSection';

const Tax = ({ totalDueTodayTaxAmount, taxText, totalDueMonthlyTaxAmount, planInfo }) => {
  const renderDueMonthly = (planInfoDetails) => {
    const flowType = getFlowType();
    const appId = getAPPID();
    const isSelfSetup = enableSelfSetup();

    let itemType;
    let taxname;
    let taxValue = null;
    let taxIncludedText = '';

    if (planInfoDetails && planInfoDetails.length > 0 && planInfoDetails[0]) {
      if (planInfoDetails[0].taxName) {
        taxname = planInfoDetails[0].taxName;
      }

      taxIncludedText = planInfoDetails[0].taxIncluded;
      if (flowType === 'LTE') {
        if (itemType === 'PLAN' && appId !== 'AAL' && !isSelfSetup) {
          taxValue = planInfoDetails[0].taxValueForPhone;
        } else {
          taxValue = planInfoDetails[0].taxValueLTE;
        }
      } else if (flowType !== 'LTE') {
        taxValue = getSession('isCBandQual') === 'Y' ? planInfoDetails[0].taxValueForTax :  planInfoDetails[0].taxValueFor5G;
            }
    }

    const totalDue =
      appId === 'AAL' && isSelfSetup
        ? taxIncludedText
        : totalDueMonthlyTaxAmount && totalDueMonthlyTaxAmount !== '0'
          ? `$${parseFloat(totalDueMonthlyTaxAmount).toFixed(2)}`
          : taxIncludedText;

    const subTitle = appId !== 'AAL' && totalDueMonthlyTaxAmount !== '0' ? 'For additional services' : taxValue || '';

    return <CommonSection leftValueText={taxname} rightValueText={totalDue} id="DueMonthly Tax Info" subTitle={subTitle} className="normalStyle" />;
  };

  const dueTodayTax = totalDueTodayTaxAmount !== null && totalDueTodayTaxAmount !== undefined && totalDueTodayTaxAmount !== '';
  const dueMonthlyTax = totalDueMonthlyTaxAmount !== null && totalDueMonthlyTaxAmount !== undefined && totalDueMonthlyTaxAmount !== '';

  return (
    <>
      {dueTodayTax && (
        <CommonSection
          leftValueText={taxText}
          rightValueText={`$${parseFloat(totalDueTodayTaxAmount).toFixed(2)}`}
          id="DueToday TaxInfo"
          className="normalStyle"
        />
      )}
      {dueMonthlyTax && renderDueMonthly(planInfo)}
    </>
  );
};

Tax.propTypes = {
  totalDueTodayTaxAmount: PropTypes.number,
  taxText: PropTypes.string,
  planInfo: PropTypes.any,
  totalDueMonthlyTaxAmount: PropTypes.any,
};
export default Tax;
